/* src/app/agent-builder/agent-builder-messages-log-detail/agent-builder-messages-log-detail-expandable/agent-builder-messages-log-detail-expandable.component.scss */
.text-container {
  position: relative;
  overflow: hidden;
  max-height: calc(var(--max-lines) * 1.4em);
  transition: max-height 0.25s ease;
}
.text-container.expanded {
  max-height: 100%;
}
.text-content {
  white-space: pre-wrap;
  line-height: 1.4em;
  font-size: 14px;
}
.toggle {
  margin-top: 6px;
  font-size: 13px;
  color: #1890ff;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}
.chevron {
  transition: transform 0.25s ease;
}
/*# sourceMappingURL=agent-builder-messages-log-detail-expandable.component.css.map */
